import { headings } from './headings.js';

function control(event, keysPressed) {
  // saving
  if (keysPressed['Control'] && event.key == 's') {
    event.preventDefault();
    console.log("ctrl+s");
  }

  // Note: Blocking Ctrl+W doesn't work in Chrome and new Firefox
  if (keysPressed['Control'] && event.key == 'w') {
    event.preventDefault();
  }

  // headings
  // todo: english keyboard
  headings(event, keysPressed);

  // remove formating
  if (keysPressed['Control'] && event.key == ';') {
    event.preventDefault();
    document.execCommand('removeFormat', false);
    document.execCommand('formatBlock', false, 'p');
  }
}

export { control }